export type TierPriceFields = {
  price: number;
  oldCsaMemberPrice: number;
};

export function userHasSubscriptionHistory(
  history: readonly unknown[] | null | undefined,
): boolean {
  return (history?.length ?? 0) > 0;
}

/** Display / expected charge in SEK for a tier given prior CSA history. */
export function resolveTierChargeAmountSek(
  tier: TierPriceFields,
  hasSubscriptionHistory: boolean,
): number {
  return hasSubscriptionHistory ? tier.oldCsaMemberPrice : tier.price;
}
